import type { AppEvent } from './customer';

export type EventSeverity = 'info' | 'warn' | 'error';

export interface EventFilters {
  event_type?: string;
  severity?: EventSeverity;
  user_id?: string;
  session_id?: string;
  screen?: string;
  date_from?: string;
  date_to?: string;
  search?: string;
}

export interface UserJourneyEvent extends AppEvent {
  time_diff_ms?: number; // Time since previous event
}

export interface ErrorSummary {
  total_errors: number;
  unique_errors: number;
  affected_users: number;
  top_errors: Array<{
    error_message: string;
    count: number;
    affected_users: number;
    last_occurrence: string;
  }>;
}

export interface PerformanceMetrics {
  total_api_calls: number;
  avg_response_time_ms: number;
  success_rate: number;
  failed_requests: number;
  by_endpoint: Array<{
    endpoint: string;
    count: number;
    avg_duration_ms: number;
    success_rate: number;
  }>;
}

// Helper functions
export const getSeverityColor = (severity: EventSeverity): string => {
  const colors: Record<EventSeverity, string> = {
    info: 'blue',
    warn: 'orange',
    error: 'red',
  };
  return colors[severity];
};

export const getSeverityLabel = (severity: EventSeverity): string => {
  const labels: Record<EventSeverity, string> = {
    info: 'Info',
    warn: 'Warning',
    error: 'Error',
  };
  return labels[severity];
};

export const formatDuration = (ms: number): string => {
  if (ms < 1000) return `${ms}ms`;
  if (ms < 60000) return `${(ms / 1000).toFixed(1)}s`;
  return `${(ms / 60000).toFixed(1)}m`;
};

